import type { RouteObject } from 'react-router-dom'
import AppLayout from './App'

import Home from './pages/Home'
import AboutPage from './features/about/AboutPage'
import Team from './pages/Team'
import TeamDetail from './pages/TeamDetail'
import Technologies from './pages/Technologies'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import PersonalProjectDetail from './pages/PersonalProjectDetail'
import Contact from './pages/Contact'
import StartProject from './pages/StartProject'
import Privacy from './pages/Privacy'
import TermsOfService from './pages/TermsOfService'
import CaseStudyDetail from './pages/CaseStudyDetail'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'team', element: <Team /> },
      { path: 'team/:id', element: <TeamDetail /> },
      { path: 'technologies', element: <Technologies /> },
      { path: 'projects', element: <Projects /> },
      { path: 'projects/:id', element: <ProjectDetail /> },
      { path: 'projects/personal/:id', element: <PersonalProjectDetail /> },
      { path: 'personal-projects/:id', element: <PersonalProjectDetail /> },
      { path: 'contact', element: <Contact /> },
      { path: 'start-project', element: <StartProject /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'terms', element: <TermsOfService /> },
      { path: 'case-studies/:id', element: <CaseStudyDetail /> },
      { path: '*', element: <Home /> },
    ],
  },
]
